import { AnyAction } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { catchError, combineLatest, concat, filter, map, mapTo, Observable, of, switchMap } from 'rxjs';
import { SmoLanguage } from '../../../../Models/Smo/SmoLanguage';
import { TextReader } from '../../../TextReader/TextReader';
import ServiceStoreActions from '../Service/ServiceStoreActions';
import { StoreDependencies } from '../StoreDependencies';
import { StoreState } from '../StoreState';
import TextReaderActions from './TextReaderActions';

function loadTextReader(
  $action: Observable<AnyAction>,
  $state: StateObservable<StoreState>,
  dependencies: Partial<StoreDependencies>
): Observable<AnyAction> {
  return combineLatest([$action, $state]).pipe(
    map(([action, state]) => ({ action, state })),
    filter(({ action }) => TextReaderActions.loadTextReader.match(action)),
    map(({ state }) => state.user.currentUser?.settings.smoLanguage ?? SmoLanguage.english),
    map((smoLanguage) => dependencies.textReaderLanguageConverter!.getTextReaderLanguageForGameLanguage(smoLanguage)),
    switchMap((language) =>
      concat(loadReader(dependencies.textReader!), setTextReaderLanguage(language, dependencies.textReader!))
    )
  );
}

function loadReader(textReader: TextReader): Observable<AnyAction> {
  return textReader.load().pipe(
    mapTo(ServiceStoreActions.setIsTesseractLoaded(true)),
    catchError(() => of(ServiceStoreActions.setIsTesseractLoaded(false)))
  );
}

function setTextReaderLanguage(language: string, textReader: TextReader): Observable<AnyAction> {
  return textReader.setLanguage(language).pipe(map(TextReaderActions.setLanguage));
}

export default combineEpics(loadTextReader);
